export const MODAL_NUMBERS = {
  CP_TEXTING_SUBSCRIPTION_SUCCESS: 1,
  CHOOSE_NEW_NUMBER: 2,
  CONFIRM_NUMBER: 3,
  CONFIRM_NUMBER_SUCCESS: 4,
  CONFIRM_NUMBER_FAILURE: 5,
  TCR_APPROVAL_PENDING: 6,
  // Telnyx-gated pre-number decision: "Get a new number OR Port?". Shown to
  // Telnyx-gated users before CHOOSE_NEW_NUMBER. Lumian users never see this.
  CHOOSE_NEW_OR_PORT: 7,
  // The TCR_APPROVAL_PENDING modal, opened after a successful sole-proprietor
  // PIN (TCRApprovalStep handleVerify) to point at the Setup Assistant. Same
  // modal; this number tells it the phone is now verified.
  TCR_APPROVAL_PENDING_PHONE_VERIFIED: 8,
};

export const TCR_REGISTRY_STEPS = {
  intro: {
    key: 0,
    label: 'The Campaign Registry™'
  },
  businessInfo: {
    key: 1,
    label: 'TCR Registration'
  },
  useCase: {
    key: 2,
    label: 'TCR Use-Case Details'
  },
  approval: {
    key: 3,
    label: 'Approval'
  },
};

export const BUSINESS_TYPES = {
  SOLE_PROPRIETOR: { value: 'sole proprietor', label: 'Sole Proprietor' },
  COMPANY: { value: 'company', label: 'Private Company' },
};

export const BUSINESS_TYPE_OPTIONS = Object.values(BUSINESS_TYPES);

export const CONTACT_OPT_IN_METHOD_TYPES = {
  GENERAL_CONSENT:
  {
    value: 'general consent',
    label: 'General Consent',
    description: 'Contacts supply their consent to receive messages verbally in person or on a call, through email, personal text, or chat app conversations. Contacts are asked "Would you like to receive text messages? You may opt-out at any time by replying STOP, reply HELP for help, message frequency may vary, and message and data rates may apply, and no mobile information will be shared with third parties/affiliates for marketing/promotional purposes."',
  },
  CP_OPT_IN: {
    value: 'cp opt-in',
    label: 'CP Opt-In',
    description: 'Contacts supply their consent to receive messages first by sending a text message. The system responds with an opt-in message that includes a form link to accept receiving text messages.  After the form is submitted, system responds with a confirmation stating that they have joined the registered brands text list, they can opt-out at any time by replying Stop, they can reply Help for help, message frequency may vary, and message and data rates may apply, and that no mobile information will be shared with third parties/affiliates for marketing/promotional purposes.\n\nLink To Example Form: https://app.connectionpointsoftware.com/o/oe77235dd'
  },
  CUSTOM_INTERNET_FORM: {
    value: 'custom internet form',
    label: 'Custom Form on the Internet',
    description: 'Contacts give their consent to receive messages using the following form.\n\nForm URL: [Provide URL To Web Form]\n\nThe form states they can opt-out at any time by replying Stop, they can reply Help for help, message frequency may vary, and message and data rates may apply, and that no mobile information will be shared with third parties/affiliates for marketing/promotional purposes.'
  },
  CUSTOM: {
    value: 'custom',
    label: 'Custom - Enter how contacts opt in to your texts',
    description: '',
  },
};

export const CONTACT_OPT_IN_METHOD_OPTIONS = Object.values(CONTACT_OPT_IN_METHOD_TYPES);

// Phone Number Port Steps
export const PHONE_NUMBER_PORT_STEPS = {
  accountDetails: {
    key: 0,
    label: 'Account Details',
  },
  authorization: {
    key: 1,
    label: 'Authorization',
  },
  status: {
    key: 2,
    label: 'Status',
  },
};

// Phone Number Port Status Values (from Lumian API + CP draft)
export const PHONE_NUMBER_PORT_STATUSES = {
  // CON-1488: 'draft' is a CP-internal status — the form was saved but
  // the port has not been submitted to any provider yet. Telnyx-only.
  DRAFT: 'draft',
  UNCONFIRMED: 'unconfirmed',
  SUBMITTED: 'submitted',
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
  COMPLETED: 'completed',
  REJECTED: 'rejected',
  CANCELED: 'canceled',
};

// Carrier Types
export const CARRIER_TYPES = {
  PROJECT_BROADCAST: 'project-broadcast',
  ANOTHER_PROVIDER: 'another-provider',
};
